import { del, get, post, put } from "@/shared/api/api-client";
import { injectable } from "inversify";
import { OfferInstance, SuccessResponse } from "../ts";

@injectable()
export class OffersService {
    getAllOffers(): Promise<OfferInstance[]> {
        return get(`${PUBLIC_API_URL}/offer`, {}, document.cookie);
    }

    getOfferById(id: number): Promise<OfferInstance> {
        return get(`${PUBLIC_API_URL}/offer/${id}`, {}, document.cookie);
    }

    getOffersByBuyerId (buyerId: number) {
        return get(`${PUBLIC_API_URL}/buyeroffer/${buyerId}`, {}, document.cookie);
    }

    getOffersByBuyerMd5 (md5: string) {
        return get(`${PUBLIC_API_URL}/buyeroffer/0`, { param: md5 }, document.cookie);
    }

    createNewOffer(offerDto: Omit<OfferInstance, 'class' | 'created_at' | 'updated_at'>): Promise<SuccessResponse> {
        return post(`${PUBLIC_API_URL}/offer`, { ...offerDto }, document.cookie);
    }

    updateOfferById(id: number, updateOfferDto: Omit<OfferInstance, 'created_at' | 'class'>): Promise<OfferInstance> {
        return put(`${PUBLIC_API_URL}/offer/${id}`, { ...updateOfferDto });
    }

    updateExternalOfferById(id: number, updateOfferDto: Omit<OfferInstance, 'created_at' | 'class'>): Promise<OfferInstance> {
        return put(`${PUBLIC_API_URL}/offer_status/${id}`, { ...updateOfferDto });
    }

    deleteOfferById(id: number) {
        return del(`${PUBLIC_API_URL}/offer/${id}`,);
    }

    switchBuyerOffers({ id, is_internal, enabled }: { id: number, is_internal: boolean, enabled: boolean }) {
        return put(`${PUBLIC_API_URL}/enable_all_offers/${id}`, { enabled, is_internal });
    }
}